// Start page visits at the top before the homepage entrance becomes visible.
window.addEventListener('pageshow', function () {
  var resetScroll = !window.location.hash || window.location.hash === '#top';
  if (resetScroll) window.scrollTo(0, 0);
  if (!document.body.classList.contains('template-index')) return;

  window.requestAnimationFrame(function () {
    if (resetScroll) window.scrollTo(0, 0);
    window.requestAnimationFrame(function () {
      document.documentElement.classList.add('home-scroll-ready');
    });
  });
});

window.addEventListener('pagehide', function () {
  document.documentElement.classList.remove('home-scroll-ready');
});

// Keep a skeleton behind images, then fade each image in when it finishes loading.
(function () {
  var tracked = new WeakSet();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function updateHost(host) {
    if (!host) return;
    window.clearTimeout(host.imageSkeletonTimer);
    var pending = Array.prototype.some.call(host.children, function (child) {
      return child.tagName === 'IMG' && !child.classList.contains('is-image-loaded');
    });
    if (pending) {
      host.classList.add('image-skeleton-host');
    } else {
      host.imageSkeletonTimer = window.setTimeout(function () {
        host.classList.remove('image-skeleton-host');
      }, reducedMotion.matches ? 0 : 450);
    }
  }

  function reveal(image) {
    image.classList.add('is-image-loaded');
    updateHost(image.parentElement);
  }

  function prepare(image, sourceChanged) {
    if (!tracked.has(image)) {
      tracked.add(image);
      image.addEventListener('load', function () { reveal(image); });
      image.addEventListener('error', function () { reveal(image); });
    }

    if (sourceChanged) image.classList.remove('is-image-loaded');
    if (image.complete) {
      if (sourceChanged) {
        updateHost(image.parentElement);
        window.requestAnimationFrame(function () { reveal(image); });
      } else {
        reveal(image);
      }
    } else {
      updateHost(image.parentElement);
    }
  }

  document.querySelectorAll('img').forEach(function (image) { prepare(image, false); });
  document.documentElement.classList.add('image-loading-enabled');

  new MutationObserver(function (mutations) {
    var changed = new Set();
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        changed.add(mutation.target);
      } else {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') changed.add(node);
          node.querySelectorAll('img').forEach(function (image) { changed.add(image); });
        });
      }
    });
    changed.forEach(function (image) { prepare(image, tracked.has(image)); });
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset']
  });
})();

// Keep the product gallery frame in place while thumbnails change its image.
(function () {
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImage = gallery.querySelector('.product__image');
    var thumbnails = gallery.querySelectorAll('.product__thumbnail-button');
    if (!mainImage || !thumbnails.length) return;

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        if (thumbnail.getAttribute('aria-pressed') === 'true') return;

        mainImage.srcset = thumbnail.dataset.imageSrcset;
        mainImage.src = thumbnail.dataset.imageSrc;
        mainImage.alt = thumbnail.dataset.imageAlt;

        thumbnails.forEach(function (item) {
          item.setAttribute('aria-pressed', item === thumbnail ? 'true' : 'false');
        });
      });
    });
  });
})();

// Reveal sections as they enter the viewport, and soften storefront navigation.
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var isEditor = window.Shopify && window.Shopify.designMode;
  var revealSelector = [
    '.quarterly-home > section',
    '.quarterly-home > article',
    '.site-main > section',
    '.site-main > article',
    '.site-main .shopify-section > section',
    '.site-main .shopify-section > article'
  ].join(', ');
  var observer;

  function revealSections() {
    if (observer) observer.disconnect();
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.motion-reveal').forEach(function (section) {
        section.classList.remove('motion-reveal', 'is-visible');
      });
      return;
    }

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

    document.querySelectorAll(revealSelector).forEach(function (section) {
      if (section.classList.contains('quarterly-home__hero') || section.classList.contains('is-visible')) return;
      var bounds = section.getBoundingClientRect();
      if (bounds.top < window.innerHeight * 0.92 && bounds.bottom > 0) {
        section.classList.add('is-visible');
        return;
      }
      section.classList.add('motion-reveal');
      observer.observe(section);
    });
  }

  revealSections();
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', revealSections);
  document.addEventListener('shopify:section:load', revealSections);

  if (isEditor) return;

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || reducedMotion.matches) return;
    if (link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    var destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || !/^https?:$/.test(destination.protocol)) return;
    if (destination.pathname === window.location.pathname && destination.search === window.location.search && destination.hash) return;

    event.preventDefault();
    if (document.body.classList.contains('is-page-leaving')) return;
    document.body.classList.add('is-page-leaving');
    window.setTimeout(function () {
      window.location.assign(destination.href);
    }, 340);
    window.setTimeout(function () { document.body.classList.remove('is-page-leaving'); }, 1600);
  });

  window.addEventListener('pageshow', function () {
    document.body.classList.remove('is-page-leaving');
  });
})();

// Keep the purchase button in sync when a shopper changes size.
(function () {
  document.querySelectorAll('[data-product-variants]').forEach(function (variants) {
    var form = variants.closest('form');
    var addButton = form && form.querySelector('button[name="add"]');
    if (!addButton) return;

    variants.addEventListener('change', function () {
      var selected = variants.querySelector('input[name="id"]:checked');
      var available = selected && !selected.disabled;
      addButton.disabled = !available;
      addButton.textContent = available ? addButton.dataset.addToCartLabel : addButton.dataset.soldOutLabel;
    });
  });
})();

// Keep the homepage hero's scroll effect in sync when scroll timelines are unavailable.
(function () {
  var stage = document.querySelector('.quarterly-home__hero-stage');
  if (!stage) return;
  var header = document.querySelector('.site-header--home');
  var pin = document.querySelector('.quarterly-home__hero-pin');
  var hero = document.querySelector('.quarterly-home__hero');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktopViewport = window.matchMedia('(min-width: 1024px)');
  var cssScrollAnimation = window.CSS && CSS.supports('animation-timeline: scroll()');
  var stageTop = 0;
  var stageHeight = 0;
  var pinnedHeight = 0;

  function measure() {
    if (!stage) return;
    // Layout offsets stay stable while the page entrance translates .site-main.
    stageTop = 0;
    for (var element = stage; element; element = element.offsetParent) {
      stageTop += element.offsetTop;
    }
    stageHeight = stage.offsetHeight;
    pinnedHeight = pin ? pin.offsetHeight : 0;
    update();
  }

  function motionChanged() {
    if (reducedMotion.matches && hero) {
      hero.style.removeProperty('--hero-height');
      hero.style.removeProperty('--hero-clip');
      hero.style.removeProperty('--hero-media-scale');
      hero.style.removeProperty('--hero-copy-opacity');
    }
    measure();
  }

  function update() {
    var scroll = Math.max(0, window.scrollY || window.pageYOffset);
    if (header) header.classList.toggle('is-pinned', scroll > 0);
    if (pin) pin.classList.toggle('is-pinned', scroll > 0 && !reducedMotion.matches);
    if (header) header.classList.toggle('is-scrolled', scroll > 24);
    if (!stage || !hero || cssScrollAnimation || reducedMotion.matches || !stageHeight) return;

    var shrink = Math.min(Math.max(scroll - stageTop, 0), Math.max(0, stageHeight - pinnedHeight));
    var remaining = stageHeight - shrink;
    var clipStart = Math.max(24, stageHeight * .04);
    hero.style.setProperty('--hero-height', remaining + 'px');
    hero.style.setProperty('--hero-clip', Math.max(0, 100 * (1 - remaining / clipStart)) + '%');
    if (desktopViewport.matches) hero.style.setProperty('--hero-media-scale', 1 + .05 * shrink / stageHeight);
    else hero.style.removeProperty('--hero-media-scale');
    hero.style.setProperty('--hero-copy-opacity', Math.max(0, 1 - (scroll - stageTop) / 310));
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', measure);
  window.addEventListener('pageshow', measure);
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', motionChanged);
  measure();
})();
